"use strict";

exports.__esModule = true;
exports.UserListContext = void 0;
var _UserListController = require("./UserListController");
var _Utils = require("../../../Utils");
var UserListContext = exports.UserListContext = (0, _Utils.createEnhancedContext)({
  propName: "users",
  defaultController: _UserListController.UserListController
});